"use client"

import CommonCreate from "@/components/common/Create"
import UsersForm from "./UsersForm"
import { FC, useState } from "react";
import { singleProp } from "@/interface/dataInterface";
import { useUserContext } from "@/context/UserContext";

const UserCreate: FC<singleProp> = ({prop}) => {
    const {decodedToken} = useUserContext()

    const [formProp, setFormProp] = useState({
        firstname: "",
        lastname: "",
        email: "",
        password: "",
        user_role: "Owner",
        ...(decodedToken && decodedToken?.permissions?.settings_type === 'auto-service' && {branch_id: ""})
    });

    const dataToSend = {
        ...formProp,
        user_role: formProp.user_role.toLowerCase(),
        branch_id: formProp?.branch_id ? +formProp?.branch_id : null
    }

    return (
        <CommonCreate title="New user" resource="users" data={dataToSend} responseMessage="User added successfully">
            <UsersForm userRoles={prop} mode="create" formProp={formProp} setFormProp={setFormProp} />
        </CommonCreate>
    );
};

export default UserCreate;
